<template>
  <!-- 商品列表 -->
  <div class="productList">
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="handleRefresh"
      :crumbsList="['商品管理', $route.meta.title]"
    >
      <template slot="controls"> </template>
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <label class="label">库存：</label>
        <el-select
          v-model="searchForm.isKcNoUpdate"
          placeholder="库存是否同步"
          style="width: 100px; margin-right: 5px"
          clearable
        >
          <el-option label="全部" value=""></el-option>
          <el-option label="是" value="Y"></el-option>
          <el-option label="否" value="N"></el-option>
        </el-select>
        <label class="label">价格：</label>
        <el-select
          v-model="searchForm.isJgNoUpdate"
          placeholder="价格是否同步"
          style="width: 100px; margin-right: 5px"
          clearable
        >
          <el-option label="全部" value=""></el-option>
          <el-option label="是" value="Y"></el-option>
          <el-option label="否" value="N"></el-option>
        </el-select>

        <el-input
          v-model="searchForm.name"
          style="width: 150px; margin-right: 5px"
          clearable
          placeholder="输入编号/名称"
        >
        </el-input>
        <el-button type="primary" icon="el-icon-search" @click="getTableData(1)"
          >搜索</el-button
        >
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      tooltip-effect="dark"
      style="width: 100%"
    >
      <el-table-column label="序号" align="center" width="50">
        <template slot-scope="scope">
          <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>

      <el-table-column
        align="center"
        width="150"
        prop="code"
        show-overflow-tooltip
        label="商品编号(ERP)"
      >
      </el-table-column>
      <el-table-column
        prop="name"
        align="center"
        width="160"
        show-overflow-tooltip
        label="商品名称"
      >
      </el-table-column>
      <!-- 王航说不要了，没什么用 -->
      <!-- <el-table-column prop="entname" align="center" show-overflow-tooltip label="机构名称">
      </el-table-column> -->
      <el-table-column
        prop="specification"
        label="商品规格"
        width="120"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="packingNnit"
        label="包装单位"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="repertory"
        label="库存"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="IsKcNoUpdate"
        label="库存不同步"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <div>
            <el-switch
              v-model="scope.row.IsKcNoUpdate"
              @change="priceKuc(scope.row)"
              active-value="Y"
              inactive-value="N"
            >
            </el-switch>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="IsJgNoUpdate"
        label="价格不同步"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.IsJgNoUpdate"
            active-value="Y"
            @change="priceLevel(scope.row)"
            inactive-value="N"
          >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="100" fixed="right">
        <template slot-scope="scope">
          <el-button
            type="primary"
            plain
            style="padding: 2px 3px"
            @click="priceLevelLow(scope.row)"
            >详情</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>

    <el-dialog
      :visible.sync="explain"
      :before-close="beforeclose"
      :close-on-click-modal="$store.state.closeOnClickModal"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      width="50%"
    >
      <div>
        <div class="explainSure" v-if="priceListShow">
          <div class="explainTitle">价格设置</div>
        </div>

        <el-table
          v-if="priceListShow"
          :data="priceList"
          stripe
          border
          ref="multipleTable"
          tooltip-effect="dark"
          style="width: 100%; height: 400px; overflow: auto"
        >
          <el-table-column label="序号" type="index" width="50">
          </el-table-column>
          <el-table-column
            prop="goodName"
            label="商品名称"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="title"
            label="名称"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="price"
            label="价格"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <el-input
                v-if="caozuoShow"
                v-model="scope.row.price"
                style="width: 150px"
                min="0"
                max="9999999"
                type="number"
              ></el-input>
              <div v-else>{{ scope.row.price }}</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="price"
            label="操作"
            v-if="caozuoShow"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <el-button type="primary" @click="priceSubmit(scope.row)"
                >确定</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div>
        <div class="explainSure" v-if="NameShow">
          <div class="explainTitle">库存设置</div>
        </div>
        <el-table
          v-if="NameShow"
          :data="KCList"
          stripe
          border
          ref="multipleTable"
          tooltip-effect="dark"
          style="width: 100%; height: 400px; overflow: auto"
        >
          <el-table-column label="序号" type="index" width="50">
          </el-table-column>
          <el-table-column
            prop="goosName"
            label="商品名称"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="stockQuantity"
            label="库存数量"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <el-input
                v-if="caozuoShow"
                v-model="scope.row.stockQuantity"
                style="width: 150px"
                min="0"
                max="9999999"
                type="number"
              ></el-input>
              <div v-else>{{ scope.row.stockQuantity }}</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="price"
            label="操作"
            align="center"
            v-if="caozuoShow"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <el-button type="primary" @click="priceKcSubmit(scope.row)"
                >确定</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
//混入
import { formatStatus } from "@/mixins/filters/formatStatus.js";

export default {
  name: "goodsControl",
  mixins: [formatStatus],
  data() {
    return {
      entId: "",
      /**表格数据 */
      // {
      //   id:"商品id",
      //   code:"商品编号",
      //   name:"商品名称",
      //   entid:"机构ID",
      //   entname:"机构名称",
      //   specification:"商品规格",
      //   packingNnit:"包装单位",
      //   producer:"生产厂家",
      //   classify:"商品分类",
      //   repertory:"库存",
      //   retailPrice:"建议零售价",
      //   validTime:"效期时间",
      //   status:"状态",
      //   sort:"排序"
      // }
      tableData: [],
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
      /**搜索表单 */
      // 商品分类 商品属性 商品状态 库存状态 商品图片 活动专区 活动状态 商品名称
      searchForm: {
        classify: "",
        attr: "",
        status: "2",
        stock: "",
        pic: "",
        activityArea: "",
        activityStatus: false,
        name: "",
        isKcNoUpdate: "",
        isJgNoUpdate: "",
      },
      /**select选中项 */
      selectedList: [],
      /**搜索下拉数据 */
      attrList: [], //商品属性列表
      classifyList: [], //商品分类别表

      /**上传详情图 */
      imgType: 1, //上传图片的类型

      /**使用说明 */
      explain: false,
      priceList: [],
      priceListShow: false,
      NameShow: false,
      caozuoShow: false,
      KCList: [],
      explainTile: "价格设置",
    };
  },
  mounted() {
    this.entId = localStorage.getItem("entId");
    this.getTableData();
  },
  methods: {
    // 点击价格修改数据
    priceLevel(val) {
      this.priceKcSubmit(val, "价格");
    },
    // 点击库存修改数据
    priceKuc(val) {
      if (val.IsKcNoUpdate == "Y") {
        this.NameShow = true;
        this.priceListShow = false;
        this.caozuoShow = true;
        this.explain = true;
        this.explainTile = "库存设置";
        this.KCList = [];
        this.KCList.push({
          goosName: val.name,
          stockQuantity: val.repertory || 0,
          goodId: val.id,
          isKcNoUpdate: val.IsKcNoUpdate,
          isJgNoUpdate: val.IsJgNoUpdate,
        });
      } else {
        this.priceKcSubmit(val, "库存");
      }
    },

    // 点击详情查看数据
    priceLevelLow(val) {
      if (val.IsKcNoUpdate == "Y") {
        this.NameShow = true;
        this.priceListShow = false;
        this.caozuoShow = true;
        this.explain = true;
        this.explainTile = "库存设置";
        this.KCList = [];
        this.KCList.push({
          goosName: val.name,
          stockQuantity: val.repertory || 0,
          goodId: val.id,
          isKcNoUpdate: val.IsKcNoUpdate,
          isJgNoUpdate: val.IsJgNoUpdate,
        });
      } else if (val.IsJgNoUpdate == "Y") {
        this.KCList = [];
        this.priceList = [];
        this.priceListShow = true;
        this.caozuoShow = true;
        this.NameShow = false;
        this.explainTile = "价格设置";
        this.getGoodData(val);
      } else if (val.IsJgNoUpdate == "Y" && val.IsJgNoUpdate == "Y") {
        this.NameShow = true;
        this.priceListShow = true;
        this.caozuoShow = true;
        this.explainTile = "设置";
        this.getGoodData(val);
        this.KCList = [];
        this.priceList = [];
        this.KCList.push({
          goosName: val.name,
          stockQuantity: val.repertory || 0,
          goodId: val.id,
          isKcNoUpdate: val.IsKcNoUpdate,
          isJgNoUpdate: val.IsJgNoUpdate,
        });
      } else if (val.IsJgNoUpdate == "N" && val.IsJgNoUpdate == "N") {
        this.caozuoShow = false;
        this.NameShow = true;
        this.priceListShow = true;
        this.explainTile = "设置";
        this.getGoodData(val);
        this.KCList = [];
        this.priceList = [];
        this.KCList.push({
          goosName: val.name,
          stockQuantity: val.repertory || 0,
          goodId: val.id,
          isKcNoUpdate: val.IsKcNoUpdate,
          isJgNoUpdate: val.IsJgNoUpdate,
        });
      }
    },
    // 获取机构等级
    /**获取商品详情 */
    getGoodData(isOnlyPrice) {
      let data = {
        type: "GetGoodsDetail",
        strWhere: isOnlyPrice.id,
      };
      let proc = "Proc_Admin_GoodsList"; // 存储过程名
      let type = "ReturnDataSet";
      this.$requestSys({
        url:
          "goods/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        method: "post",
      })
        .then((res) => {
          this.priceList = [];
          this.explain = true;
          if (res.flag == 0) {
            if (isOnlyPrice) {
              if (res.table1.length !== 0) {
                res.table1.forEach((item) => {
                  this.priceList.push({
                    code: item.pricelevel,
                    name: item.pricelevel,
                    title: item.PriceName,
                    price: item.price,
                    oldprice: item.price,
                    goodName: isOnlyPrice.name,
                    goodId: isOnlyPrice.id,
                  });
                });
              }
            }
          } else {
            this.$message({
              message: "获取详情失败",
              type: "error",
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    priceSubmit(val) {
      this.$confirm("确定提交吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "success",
      })
        .then(() => {
          let data = {
            entId: window.localStorage.getItem("entId"),
            articleId: val.goodId,
            pricelevel: val.code,
            discountPrice: 0,
            price: val.price,
          };
          console.log(data);
          this.$request({
            url: "GoodsAdmin/UpdateGoodsPrice",
            method: "post",
            data: data,
          }).then((res) => {
            if (res.success) {
              this.$message({
                message: "保存成功",
                type: "success",
              });
              this.getTableData();
            } else {
              this.$message({
                message: res.message,
                type: "error",
              });
            }
          });
        })
        .catch(() => {});
    },
    priceKcSubmit(val, type) {
      if (type == "价格") {
        val.isKcNoUpdate = val.IsKcNoUpdate;
        val.isJgNoUpdate = val.IsJgNoUpdate;
        val.goodId = val.id;
        val.stockQuantity = val.repertory || 0;
        val.ControlType = "价格";
      } else if (type == "库存") {
        val.isKcNoUpdate = val.IsKcNoUpdate;
        val.isJgNoUpdate = val.IsJgNoUpdate;
        val.goodId = val.id;
        val.stockQuantity = val.repertory || 0;
        val.ControlType = "库存";
      } else {
        val.ControlType = "库存";
      }
      this.$confirm("确定提交吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "success",
      })
        .then(() => {
          let data = {
            entId: window.localStorage.getItem("entId"),
            article_id: val.goodId,
            isKcNoUpdate: val.isKcNoUpdate,
            isJgNoUpdate: val.isJgNoUpdate,
            stockQuantity: val.stockQuantity || "",
            ControlType: val.ControlType,
          };
          this.$request({
            url: "/Management/GoodsAdmin/EditGoodsRenewalControl",
            method: "post",
            data: data,
          }).then((res) => {
            if (res.success) {
              this.$message({
                message: "保存成功",
                type: "success",
              });
              // if (val.IsJgNoUpdate == "Y" && type == "价格") {
              //   this.priceList = [];
              //   this.NameShow = false;
              //   this.caozuoShow = true;
              //   this.priceListShow = true;
              //   this.explainTile = "价格设置";
              //   this.getGoodData(val);
              // }
              this.NameShow = false;
              this.caozuoShow = false;
              this.priceListShow = false;
              this.explain = false;
              this.getTableData();
            } else {
              this.$message({
                message: res.message,
                type: "error",
              });
            }
          });
        })
        .catch(() => {
          this.getTableData();
        });
    },
    beforeclose() {
      this.getTableData();
      this.explain = false;
    },
    /**获取表格 */
    getTableData(num) {
      this.currPage = num == 1 ? 1 : this.currPage;
      let data = {
        type: "GoodsList",
        category: this.searchForm.classify || "0",
        attribute: this.searchForm.attr || "0",
        status: this.searchForm.status || "9",
        IsJgNoUpdate: this.searchForm.isJgNoUpdate,
        IsKcNoUpdate: this.searchForm.isKcNoUpdate,
        strWhere: this.searchForm.name,
        PageIndex: this.currPage,
        PageSize: this.pageSize,
        promtype:
          this.searchForm.activityArea == "99"
            ? ""
            : this.searchForm.activityArea,
        // promstatus: this.searchForm.activityStatus || "99",
        promstatus: this.searchForm.activityStatus ? "Y" : "",
        goodsPic: this.searchForm.pic || "99",
        spStatus: this.searchForm.stock || "99",
      };
      let proc = "Proc_Admin_GoodsList"; // 存储过程名
      let type = "ReturnList";
      this.$requestSys({
        url:
          "goods/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        method: "post",
      })
        .then((res) => {
          this.allPage = res.recordCount;
          this.tableData = [];
          if (res.flag == 0) {
            for (let i = 0; i < res.data.length; i++) {
              this.tableData.push({
                id: res.data[i].article_id,
                code: res.data[i].goodscode,
                name: res.data[i].sub_title,
                entname: res.data[i].entname,
                entid: res.data[i].entId,
                specification: res.data[i].drug_spec,
                packingNnit: res.data[i].package_unit,
                producer: res.data[i].drug_factory,
                classify: res.data[i].category,
                repertory: res.data[i].stock_quantity,
                retailPrice: res.data[i].price,
                validTime: res.data[i].valdate,
                articleId: res.data[i].article_id,
                organId: res.data[i].adminentid,
                status: res.data[i].status,
                sort: res.data[i].sort_id,
                goods_no: res.data[i].goods_no,
                IsJgNoUpdate: res.data[i].IsJgNoUpdate,
                IsKcNoUpdate: res.data[i].IsKcNoUpdate,
              });
            }
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },
  },
};
</script>

<style scoped>
.productList {
  width: 100%;
  height: 100%;
}

/**选择上传图片类型 */
.imgType {
  padding: 20px 0 30px;
}

.imgType-item {
  width: 200px;
  height: 100px;
  margin: 20px auto 0;
  /* background-color: #409EFF; */
}

.imgType-item:first-of-type {
  margin-top: 0;
}

.imgType-item-btn {
  width: 100%;
  height: 100%;
}
.explainSure {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}
.explainTitle {
  font-size: 18px;
  margin: 10px 0;
}
.label {
  font-size: 14px;
}
</style>